// Browser geolocation + reverse geocoding (OpenStreetMap Nominatim, free, no key)
export function getBrowserPosition(timeoutMs = 8000) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation not supported"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
      (err) => reject(err),
      { enableHighAccuracy: false, timeout: timeoutMs, maximumAge: 5 * 60 * 1000 },
    );
  });
}

export async function reverseGeocode({ latitude, longitude }) {
  const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}&zoom=10&accept-language=en`;
  const res = await fetch(url, { headers: { "Accept": "application/json" } });
  if (!res.ok) throw new Error("Reverse geocoding failed");
  const data = await res.json();
  const a = data.address || {};
  return {
    city: a.city || a.town || a.village || a.municipality || a.county || null,
    region: a.state || a.region || null,
    country: a.country || null,
    latitude,
    longitude,
  };
}

export async function detectLocation() {
  const pos = await getBrowserPosition();
  return await reverseGeocode(pos);
}
